/*
 * ByLamari: Produktseite des übertragenen Hydrogen-Neubaus (Theme-Kopie B, 25.10.2026), Teil 2.
 * Themen-Stapel (components/produkt/ThemenStapel.tsx): Tippen auf eine Kachel holt ihre Karte animiert nach oben
 * (FLIP mit Feder-Kurven, nur transform und opacity, „Bewegung reduzieren“ ohne Animation).
 * Seit 3.11.2026 sitzen die Kacheln in einer Leiste wie die Gold/Silber-Auswahl: --bl-tl-index schiebt den Pill
 * (Gleiten per CSS-Übergang in bl-n-themen.css).
 */
(function () {
  /* ── Themen-Stapel ─────────────────────────────────────────────────── */
  var sek = document.querySelector('[data-bl-themen]');
  var DAUER = 600, FLUG = 500, PLATZ_START = 90, STAFFEL = 22;
  function feder(ms, start, dauer, dae) {
    var x = (ms - start) / 1000;
    if (x <= 0) return 0;
    if (ms >= start + dauer) return 1;
    var w = 5 / (dae * (dauer / 1000)), wd = w * Math.sqrt(1 - dae * dae);
    return 1 - Math.exp(-dae * w * x) * (Math.cos(wd * x) + ((dae * w) / wd) * Math.sin(wd * x));
  }
  function bogen(ms, dauer) { var x = Math.min(1, Math.max(0, ms / dauer)); return Math.sin(Math.PI * x); }
  function abheben(ms) {
    if (ms <= 120) return 1 - Math.pow(1 - ms / 120, 3);
    if (ms <= 200) return 1;
    var x = Math.min(1, (ms - 200) / 220);
    return 1 - x * x * (3 - 2 * x);
  }
  function still() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  if (sek) {
    var kreise = sek.querySelector('.bl-themen__kreise');
    var stapel = sek.querySelector('.bl-themen__karten');
    var ansage = sek.querySelector('[data-bl-themen-ansage]');
    var laufend = [];
    var karten = function () {
      var m = {};
      Array.prototype.forEach.call(stapel.children, function (el) { if (el.dataset.thema) m[el.dataset.thema] = el; });
      return m;
    };
    var reihe = function () { return Array.prototype.map.call(stapel.children, function (el) { return el.dataset.thema; }); };
    var beenden = function () { laufend.forEach(function (a) { a.finish(); }); laufend = []; };
    var insBild = function (id, ruhig) {
      var karte = karten()[id];
      if (!karte) return;
      var verhalten = ruhig ? 'instant' : 'smooth';
      var knopf = document.getElementById('kachel-' + id);
      if (knopf) {
        var r = knopf.getBoundingClientRect(), rr = kreise.getBoundingClientRect();
        if (r.left < rr.left || r.right > rr.right) kreise.scrollTo({ left: kreise.scrollLeft + r.left - rr.left - (rr.width - r.width) / 2, behavior: verhalten });
      }
      var grenzeOben = parseFloat(getComputedStyle(sek).scrollMarginTop) || 80;
      var grenzeUnten = window.innerHeight - 120;
      var reiheOben = kreise.getBoundingClientRect().top;
      var titelUnten = karte.getBoundingClientRect().top + 96;
      var delta = 0;
      if (reiheOben < grenzeOben) delta = reiheOben - grenzeOben;
      else if (titelUnten > grenzeUnten) delta = Math.min(titelUnten - grenzeUnten, reiheOben - grenzeOben);
      if (Math.abs(delta) > 1) window.scrollBy({ top: delta, behavior: verhalten });
    };
    var leiste = sek.querySelector('[data-bl-themen-leiste]');
    var markieren = function () {
      var r = reihe();
      sek.querySelectorAll('.bl-themen__kreis').forEach(function (b, i) {
        b.setAttribute('aria-pressed', String(b.dataset.blThema === r[0]));
        if (leiste && b.dataset.blThema === r[0]) leiste.style.setProperty('--bl-tl-index', String(i));
      });
      Array.prototype.forEach.call(stapel.children, function (el, i) { if (i === 0) el.setAttribute('data-oben', ''); else el.removeAttribute('data-oben'); });
    };
    var tippen = function (id) {
      beenden();
      var ruhig = still();
      var els = karten();
      var titel = els[id] ? els[id].querySelector('h3').textContent : '';
      var alt = reihe();
      if (id === alt[0]) {
        if (els[id] && !ruhig) laufend = [els[id].animate([{ transform: 'none' }, { transform: 'scale(1.015)', offset: 0.35 }, { transform: 'none' }], { duration: 360, easing: 'ease-in-out' })];
        insBild(id, ruhig);
        ansage.textContent = titel;
        return;
      }
      var vorher = {};
      Object.keys(els).forEach(function (t) { vorher[t] = els[t].getBoundingClientRect(); });
      var y = window.scrollY;
      stapel.insertBefore(els[id], stapel.firstChild);
      markieren();
      ansage.textContent = titel;
      window.scrollTo({ top: y, behavior: 'instant' });
      var nach = {};
      Object.keys(els).forEach(function (t) { nach[t] = els[t].getBoundingClientRect(); });
      insBild(id, ruhig);
      if (ruhig) return;
      var altIdx = alt.indexOf(id);
      var zeiten = [];
      for (var t = 0; t < DAUER; t += 1000 / 60) zeiten.push(t);
      zeiten.push(DAUER);
      var linear = { duration: DAUER, easing: 'linear' };
      var bilder = function (f) { return zeiten.map(function (z) { var k = f(z); k.offset = z / DAUER; return k; }); };
      var anims = [];
      Object.keys(els).forEach(function (tid) {
        var el = els[tid], r0 = vorher[tid], r1 = nach[tid];
        var dd = r0.top - r1.top;
        if (Math.abs(dd) < 0.5) return;
        if (tid === id) {
          if (r0.top > window.innerHeight) dd = Math.min(dd, Math.max(window.innerHeight - r1.top, 0) + 48);
          anims.push(
            el.animate(bilder(function (z) { return { transform: 'translateY(' + (dd * (1 - feder(z, 0, FLUG, 0.8))).toFixed(2) + 'px) scale(' + (1 + 0.03 * abheben(z)).toFixed(4) + ')' }; }), linear),
            el.animate(bilder(function (z) { return { opacity: abheben(z).toFixed(3) }; }), Object.assign({ pseudoElement: '::before' }, linear))
          );
        } else {
          var j = alt.indexOf(tid);
          var start = PLATZ_START + Math.min(4, Math.max(0, altIdx - 1 - j)) * STAFFEL;
          anims.push(el.animate(bilder(function (z) { return { transform: 'translateY(' + (dd * (1 - feder(z, start, DAUER - start, 0.85))).toFixed(2) + 'px) scale(' + (1 - 0.02 * bogen(z - start, (DAUER - start) * 0.8)).toFixed(4) + ')' }; }), linear));
        }
      });
      var kb = document.querySelector('#kachel-' + id + ' .bl-themen__bild');
      if (kb) anims.push(kb.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.9)', offset: 0.2 }, { transform: 'scale(1.08)', offset: 0.55 }, { transform: 'scale(1)' }], { duration: 480, easing: 'ease-in-out' }));
      laufend = anims;
    };
    kreise.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bl-thema]');
      if (b) tippen(b.dataset.blThema);
    });
  }
})();